import { Button, Modal } from "react-bootstrap";

const DeclineConfirmModel = ({ logoUrl, logoRedirectUrl, showDeclineModel, handleConfirmDecline, handleCloseDecline }) => {
    return (
        <Modal show={showDeclineModel} onHide={handleCloseDecline} backdrop="static" keyboard={false} centered>
            <Modal.Header closeButton style={{ textAlign: 'center', alignItems: 'center' }}>
                <a href={logoRedirectUrl || "/"}
                    target={logoRedirectUrl ? "_blank" : "_self"} rel="noopener noreferrer">
                    <img src={logoUrl} alt="logo" style={{ height: 'auto', width: 'auto', maxHeight: 70, maxWidth: 165 }} />
                </a>
                <Modal.Title>Decline all coverages</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Please confirm that you'd like to decline all coverages.
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseDecline}> Cancel </Button>
                <Button variant="success" onClick={handleConfirmDecline}> Confirm </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeclineConfirmModel;